export default __webpack_public_path__ + "static/media/card_info_red_background.0009df12.svg";